module.exports = __webpack_public_path__ + "img/9788963714448.126cbe4d.jpg";